import {
  WSAvatar,
  WSDivider,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { useUserId } from "../../query/hooks/helpers";
import { useQueryUnsentInvoices } from "../../query/payments/queries";
import {
  getInvoices,
  getIsInvoiceCreator
} from "../../query/payments/selectors";
import { DownloadInvoicesCSV } from "./DownloadInvoicesCSV";
import { InvoicesTable } from "./InvoicesTable";

export const TableInvoicesUnsent: React.FC = () => {
  const userId = useUserId();
  const queryUnsentInvoices = useQueryUnsentInvoices();

  const invoices = getInvoices(queryUnsentInvoices.data || []).filter(invoice =>
    getIsInvoiceCreator(invoice, userId)
  );

  return (
    <InvoicesTable
      title="Unsent"
      invoices={invoices}
      actions={
        <DownloadInvoicesCSV
          invoices={invoices}
          isDataReady={queryUnsentInvoices.status === "success"}
        />
      }
      emptyState={
        <>
          <WSText.Heading5 mb="XL">Unsent</WSText.Heading5>
          <WSDivider mb="XL" />
          <WSFlexBox direction="column" alignItems="center" wrap="nowrap">
            <WSFlexBox mb="M">
              <WSAvatar.Icon
                icon="edit"
                color="gray500"
                colorBackground="gray50"
                mr="M"
              />
              <WSAvatar.Icon
                icon="calendar"
                color="gray500"
                colorBackground="gray50"
              />
            </WSFlexBox>
            <WSText color="gray500">Draft invoices will be listed here</WSText>
          </WSFlexBox>
        </>
      }
      mb="3XL"
    />
  );
};
